import { render, staticRenderFns } from "./DirectChatWindow.vue?vue&type=template&id=86af66d4&scoped=true&"
import script from "./DirectChatWindow.vue?vue&type=script&lang=js&"
export * from "./DirectChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./DirectChatWindow.vue?vue&type=style&index=0&id=86af66d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86af66d4",
  null
  
)

export default component.exports